import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_97fwzxfjvs: FaireBrandEntity = {
  token: "b_97fwzxfjvs",
  type: "brand",
  name: "Simply Happy",
  avatarUrl:
    "https://cdn.faire.com/fastly/839051ef3baead9e99234a4c3464e5efdb2ae53191c9cb9a6805d0efbe106b99.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a00655f9578e0df224300cebe976ac0fe238100ca467364cd907adadcea125c6.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/839051ef3baead9e99234a4c3464e5efdb2ae53191c9cb9a6805d0efbe106b99.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a00655f9578e0df224300cebe976ac0fe238100ca467364cd907adadcea125c6.jpeg",
  location: "Lindstrom, MN, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 13,
  isTopShop: true,
  isInsider: true,
  description:
    "At Simply Happy, we believe joy is found in the simple things—quiet moments, clean ingredients, and goods made with love.\n\nOur journey began in a cozy Minnesota kitchen, where a stay-at-home mom with a passion for wellness started crafting products her family could feel good about using. What began as a personal mission to remove toxins from the home grew into a full-fledged business rooted in faith, family, and intentional living.\n\nFrom our whipped tallow balms to magnesium mists, handcrafted soaps, and clean-burning candles, every Simply Happy product is made by hand in small batches right here in Lindstrom, Minnesota. We use only the cleanest ingredients, sourcing grass-fed tallow locally and choosing scents and botanicals that soothe, uplift, and restore.\n\nMore than just products, Simply Happy is a return to what matters—health, home, and heart. We believe wellness shouldn't be complicated. That the things we put on and around our bodies should be as nourishing as the meals we serve at the table. And that beauty is found in simplicity.\n\nOur name is our mission: to create with purpose, to live with gratitude, and to help others feel simply happy—one product, one family, one home at a time.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:28.123Z",
    importedBy: "entity-db-cli",
  },
};
